import React, { useRef, useContext, useState, useEffect, useCallback } from "react";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import printer from "../../assets/Printer.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import { toLowercaseKeys } from "../../helpers/toLowerCaseKeys";
import { Dropdown } from 'react-bootstrap';
import ModuleListSideBar from "./ModuleListSideBar";
import { moduleListService } from "../../services/module-list.service";
import { SetModuleEdit } from "../../store/moduleListAtom";


const ModuleDetailsPage = () => {
    const setModuleEdit = SetModuleEdit();
    const myPromiseModal = createModal(GeneralModal);
    const [isToggling, setIsToggling] = useState(false);

    const { id } = useParams();
    const navigate = useNavigate();
    const logicContext = useContext(LogicContext);
    const [moduleData, setModuleData] = useState({
        module_info: [],
        action_status: [],
    });

    const { pathname } = useLocation();
    const printRef = useRef(null);

    const url = pathname.split("/");
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];

    useEffect(() => {
        document.title = "Module Details";
        let isMounted = true;

        if (isMounted) {
            loadDetailsData();
        }

        return () => {
            isMounted = false;
        };
    }, [id]);


    const loadDetailsData = () => {
        moduleListService.getModuleDetails(id).then((response) => {
            const serverData = toLowercaseKeys(response.data);
            if (serverData) {
                setModuleData(serverData);
            }
        });
    }

    const editCurrentData = async () => {
        const response = await myPromiseModal({
            title: "Modify Module",
            body: "Do you want to modify this module?",
            showInput: false,
        });

        if (response.decision === true) {
            setModuleEdit(moduleData?.module_info[0]);
            navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
        }
    };

    async function bulkActionsSingle(action) {
        const option = action.action_option;
        const result = await myPromiseModal({
            title: 'Confirm your action!',
            body: `Do you want to ${action.status_name} ?`,
            showInput: false,
            placeHolder: '',
        });
        if (result.decision === false) {
            return;
        }

        try {
            const payload = { option: option, ref_no: id }
            // Update this to use the appropriate service for module actions
            // const res = await moduleListService.moduleAction(payload);
            // const response = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

            // if (response.message_id === 1) {
            //     logicContext.showToast(response.message_text || 'Action completed successfully!', 'success');
            //     loadDetailsData();
            // } else {
            //     logicContext.showToast(response.message_text || 'Failed to complete action', 'error');
            // }

        } catch (error) {
            console.log("error", error);
        }
    }

    const getStatusColor = (statusName) => {
        switch (statusName?.toLowerCase()) {
            case "active":
                return "bg-emerald-100 text-emerald-700 border-emerald-200";
            case "inactive":
                return "bg-rose-100 text-rose-700 border-rose-200";
            case "pending":
                return "bg-amber-100 text-amber-700 border-amber-200";
            default:
                return "bg-slate-100 text-slate-700 border-slate-200";
        }
    };

    const viewItemDetails = useCallback(
        (itemId) => {
            navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${itemId}`);
        },
        [currModuleId, currModuleName, currUserMenu, navigate]
    );

    const currentModule = moduleData?.module_info?.[0];

    return (
        <section className="mt-4 w-full mx-auto px-4 sm:px-6 lg:px-8">
            {/* Action Buttons */}
            <div className="flex justify-end gap-3 mb-6">
                {moduleData?.action_status?.length > 0 &&
                    <Dropdown>
                        <Dropdown.Toggle
                            className="text-sm text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-lg transition-all duration-200 shadow-md flex items-center gap-2"
                            id="dropdown-basic"
                        >
                            ACTIONS
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="mt-2 shadow-2xl border-none rounded-xl bg-white/95 backdrop-blur-sm overflow-hidden py-0">
                            {moduleData?.action_status?.map((option, i) => (
                                <Dropdown.Item
                                    key={i}
                                    onClick={() => bulkActionsSingle(option)}
                                    className="hover:bg-blue-50 py-2.5 px-4 text-gray-700 text-sm border-b border-gray-50 last:border-0 transition-colors"
                                >
                                    {option?.status_name}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                }

                <button
                    onClick={editCurrentData}
                    className="p-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition"
                    title="Edit"
                >
                    <img src={pencil} alt="Edit" className="w-6 h-6" />
                </button>

                <button
                    className="p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition opacity-50 cursor-not-allowed"
                    title="Delete (not implemented)"
                >
                    <img src={trash} alt="Delete" className="w-6 h-6" />
                </button>
            </div>

            <div className="flex flex-col lg:flex-row gap-8">
                {/* Left Sidebar - Module List */}
                <div className="">
                    <ModuleListSideBar viewItemDetails={viewItemDetails} />
                </div>

                {/* Main Module Details Card */}
                <div ref={printRef} className="flex-1">
                    <div className="bg-white shadow-2xl rounded-2xl overflow-hidden border border-gray-100">
                        {/* Header Banner */}
                        <div className="h-32 bg-gradient-to-r from-blue-600 to-blue-500 relative">
                            <div className="absolute -bottom-12 left-8 flex items-end gap-6">
                                <div className="w-24 h-24 bg-white rounded-2xl shadow-lg flex items-center justify-center p-1">
                                    <div className="w-full h-full bg-blue-50 rounded-xl flex items-center justify-center text-blue-600">
                                        <span className="text-3xl font-bold">
                                            {currentModule?.module_name?.charAt(0) || "M"}
                                        </span>
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <h1 className="text-2xl font-bold text-white drop-shadow-md mb-4">
                                        {currentModule?.module_name || "Module Details"}
                                    </h1>
                                    <div className="flex items-center gap-2 text-blue-100 text-sm mt-1 font-medium">
                                        <span className="px-2 py-0.5 bg-white/20 rounded-md backdrop-blur-sm">
                                            ID: {currentModule?.module_id || "—"}
                                        </span>
                                        <span className={`px-2 py-0.5 rounded-md border backdrop-blur-sm ${getStatusColor(currentModule?.status_name)}`}>
                                            {currentModule?.status_name || "Unknown"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="p-8 pt-16">
                            {/* Module Information Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                {/* Module Basic Information */}
                                <div className="bg-gray-50/50 p-6 rounded-2xl border border-gray-100">
                                    <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4 flex items-center gap-2">
                                        <i className="fas fa-cube text-blue-400"></i> Module Information
                                    </h3>
                                    <div className="space-y-4">
                                        <div>
                                            <p className="text-xs text-gray-500 font-medium">Module ID</p>
                                            <p className="font-semibold text-gray-800">{currentModule?.module_id || "—"}</p>
                                        </div>
                                        <div>
                                            <p className="text-xs text-gray-500 font-medium">Module Name</p>
                                            <p className="font-semibold text-gray-800">{currentModule?.module_name || "—"}</p>
                                        </div>
                                        <div>
                                            <p className="text-xs text-gray-500 font-medium">Status ID</p>
                                            <p className="font-semibold text-gray-800">{currentModule?.status_id || "—"}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Status Information */}
                                <div className="bg-gray-50/50 p-6 rounded-2xl border border-gray-100">
                                    <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4 flex items-center gap-2">
                                        <i className="fas fa-info-circle text-blue-400"></i> Status Details
                                    </h3>
                                    <div className="space-y-4">
                                        <div>
                                            <p className="text-xs text-gray-500 font-medium">Current Status</p>
                                            <div className="flex items-center gap-3 mt-2">
                                                <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold ${currentModule?.status_name === 'Active'
                                                    ? 'bg-emerald-500 text-white'
                                                    : 'bg-slate-400 text-white'
                                                    }`}>
                                                    {currentModule?.status_name || "—"}
                                                </span>
                                            </div>
                                        </div>
                                        <div>
                                            <p className="text-xs text-gray-500 font-medium">Status ID</p>
                                            <p className="font-semibold text-gray-800">{currentModule?.status_id || "—"}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Subscription Features Section */}
                                <div className="md:col-span-2 bg-gradient-to-br from-blue-50 to-blue-50 p-6 rounded-2xl border border-blue-100">
                                    <h3 className="text-xs font-bold text-blue-400 uppercase tracking-wider mb-4 flex items-center gap-2">
                                        <i className="fas fa-star text-blue-400"></i> Subscription Features
                                    </h3>
                                    <div className="bg-white/80 backdrop-blur-sm p-4 rounded-xl border border-blue-100">
                                        <p className="text-sm text-gray-700 leading-relaxed">
                                            {currentModule?.module_description || "All subscription features will be here"}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ModuleDetailsPage;